<button class="btn border-0 px-1 py-0 mx-2"
        [ngClass]="{ 'btn-outline-primary': allowRetry, 'btn-outline-secondary': !allowRetry }"
        [disabled]="!allowRetry"
        (click)="allowRetry && retrySync()">
  <fa-icon [icon]="['fas', 'refresh']"></fa-icon>
</button>